import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'dva';
import { Link } from 'dva/router';
import { Row, Table, Tooltip, Spin, Drawer, Modal } from 'antd';
import moment from 'moment-timezone';
import Sticky from 'react-sticky-el';
import LeadDetailsCard from '../LeadDetailsCard/LeadDetailsCard';
import {
  BuildingIcon,
  BoltIcon,
  LinkIcon,
  EyeIcon,
  EyeFillIcon,
  NetworkCrossedIcon,
  NetworkIcon,
  HubspotCharcoalIcon,
  HubspotCoralIcon,
  HubspotWhiteIcon,
} from '../../Icons';
import helpers from '../../../utils/helpers';
import { AjaxTable, ExportFile, LeadsCompaniesFilter } from '../../../components';
import styles from '../styles.less';
import MultiplyItemsColumnRender from '../../common/Table/MultiplyItemsColumnRender';
import { defaultCountriesTableConfig } from '../../../utils/dataTable';
import CountryColumnRenderer from '../../common/Table/CountryColumnRenderer';
import DateTimeColumnRenderer from '../../common/Table/DateTimeColumnRenderer';
import { SearchCreateCompanyModal, ViewHubspotTransfer } from '../index';
import { WithMarkIspPermissions, WithHideCompanyPermissions, WithHubspotProjectPermissions } from '../../Permissions';
import CreateHubspotTransferModal from '../Hubspot/CreateHubspotTransferModal';

class LeadsCompaniesOverview extends React.Component {
  constructor(props) {
    super(props);

    this.defaultFilters = this.props.companies.filter;

    this.state = {
      tableKeepPage: false,
      projectId: this.props.currentProjectId || Number(this.props.match.params.projectId),
      period: [],
      sorting: defaultCountriesTableConfig.sorting,
      showKompassBranches: false,
      classificationCodes: [],
      isShowDrawer: false,
      filters: this.defaultFilters, // hubspot features
      searchCreateCompanyModalVisible: false,
      createHubspotTransferModalVisible: false,
      viewHubspotTransferDrawerVisible: false,
      replaceTableRecords: [],
      viewHubspotTransfer: null,
      transferToHubspot: {
        hasHubspotTransferClaim: null,
        companyId: null,
        companyName: null,
        hubspotCompanyId: null,
        tableRecord: null,
      },
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.Leads.CompaniesList.Title', description: 'Component.Leads.CompaniesList.Description',
      },
    });

    this.props.dispatch({ type: 'app/showNotifications' });

    this.getClassificationCodes();
  }

  onQuickView = (projectId, leadId) => {
    this.setState({ projectId, leadId });

    this.props.dispatch({
      type: 'leads/getDetails',
      payload: {
        projectId, leadId,
      },
    }).then((leadDetails) => {
      this.props.dispatch({
        type: 'matomo/updateStore', payload: { leadDetails },
      });

      return this.props.dispatch({ type: 'leadLabels/loadList' });
    }).then(({ data }) => this.props.dispatch({
      type: 'leadLabels/updateStore', payload: { allLeadMarks: data },
    }));

    this.toggleDrawer();
  }

  onTaskCreateCancel = () => {
    this.setState({
      searchCreateCompanyModalVisible: false,
    });
  }

  onTransferCreated = (hubspotTransfer) => {
    const record = {
      ...this.state.transferToHubspot.tableRecord,
      hubspot_transfer_id_recent: hubspotTransfer.id,
      hs_company_id: hubspotTransfer.hs_company_id,
      hs_deal_id: hubspotTransfer.hs_deal_id,
    };

    this.setState({
      transferToHubspot: {},
      createHubspotTransferModalVisible: false,
      viewHubspotTransferDrawerVisible: true,
      replaceTableRecords: [record],
      viewHubspotTransfer: {
        hubspotTransferId: record.hubspot_transfer_id_recent,
      },
    });
  }

  onTransferToHubspot = (record) => {
    // we already have a mapping, but task not created yet, queue working on it
    if (record.has_hubspot_transfer_claim && record.hs_company_id) {
      return Modal.info({
        content: this.props.intl.formatMessage({ id: 'Component.SearchCreateCompanyModal.Info.PendingTaskCreatingInProgress' }),
      });
    }

    this.setState({
      viewHubspotTransfer: null,
      searchCreateCompanyModalVisible: !record.hs_company_id,
      createHubspotTransferModalVisible: !!record.hs_company_id,
      transferToHubspot: {
        hasHubspotTransferClaim: record.has_hubspot_transfer_claim,
        companyId: record.id,
        companyName: record.company_name,
        companyDomain: record.domain,
        tableRecord: record,
        hubspotCompanyId: record.hs_company_id,
      },
    });
  }

  onTransferredToHubSpot = (record) => {
    this.setState({
      viewHubspotTransferDrawerVisible: true,
      viewHubspotTransfer: {
        hubspotTransferId: record.hubspot_transfer_id_recent,
      },
    });
  }

  getClassificationCodes(id = '[null]') {
    this.props.dispatch({
      type: 'branches/getKompassBranchesList', payload: { id },
    }).then(resp => this.setState({ classificationCodes: resp.data }));
  }


  getData(psf) {
    const { projectId } = this.state;

    this.setState({
      sorting: psf.sorting, tableKeepPage: false,
    });

    return this.props.dispatch({
      type: 'companies/loadList',
      payload: {
        ...psf,
        projectId,
        filter: this.filtersToQueryFilter(((filters) => {
          this.props.dispatch({ type: 'companies/filter', payload: filters });
          return filters;
        })(this.props.companies.filter)),
      },
    });
  }

  showCreateTaskPanel = (hubspotCompanyId, lxpCompanyId) => {
    this.setState({
      searchCreateCompanyModalVisible: false,
      createHubspotTransferModalVisible: true,
      transferToHubspot: {
        ...this.state.transferToHubspot, hubspotCompanyId, companyId: lxpCompanyId,
      },
    });
  }

  hideCreateHubspotTransferModal = () => {
    this.setState({
      viewHubspotTransferDrawerVisible: false, createHubspotTransferModalVisible: false, transferToHubspot: {},
    });
  }

  hideViewHubspotTransferDrawer = () => {
    this.setState({
      createHubspotTransferModalVisible: false, viewHubspotTransferDrawerVisible: false, viewHubspotTransfer: null,
    });
  }

  matchCompanyToCreatePendingTask = async (hsCompanyId, lxpCompanyId) => {
    if (hsCompanyId) {
      await this.props.dispatch({
        type: 'hubspot/linkHubspotCompany',
        payload: {
          projectId: this.state.projectId,
          lxpCompanyId,
          hsCompanyId,
        },
      });
    } else {
      await this.props.dispatch({
        type: 'hubspot/createHubspotCompany',
        payload: {
          projectId: this.state.projectId,
          lxpCompanyId,
        },
      });
    }

    this.setState({
      transferToHubspot: {},
      searchCreateCompanyModalVisible: false,
      createHubspotTransferModalVisible: false,
      viewHubspotTransferDrawerVisible: true,
      viewHubspotTransfer: null,
      updateTimestamp: Date.now(),
    });
  }

  updateFiltersState = (filters) => {
    this.props.dispatch({ type: 'companies/filter', payload: filters });
    this.setState({ filters });
  }

  hideCompanyToggle = (id, hide) => {
    this.props.dispatch({
      type: 'leads/setHidden', payload: { companyId: id, hidden: hide, projectId: this.state.projectId },
    }).then(() => {
      this.refreshTableAndKeepPage();
    });
  }

  markISP(id, isp) {
    this.props.dispatch({
      type: 'leads/markISP', payload: { id, mark: isp },
    }).then(() => {
      this.refreshTableAndKeepPage();
    });
  }

  refreshTableAndKeepPage() {
    this.setState({
      updateTimestamp: Date.now(),
      tableKeepPage: true,
    });
  }

  toggleDrawer = () => {
    this.setState(prevState => ({
      isShowDrawer: !prevState.isShowDrawer,
    }));
  }

  filtersToQueryFilter = (filters) => {
    const {
      companyName,
      dateRange,
      leadMarks,
      countries,
      city,
      branches,
      companyVisibility,
      hubspotTransfer,
      lastSource,
      lastCampaignKeyword,
      lastCampaignName,
    } = filters;

    const filterParams = {};

    switch (hubspotTransfer) {
      case 'HAS_HUBSPOT_TRANSFER':
        filterParams.has_hubspot_transfer_for_recent_visit = '1';
        break;
      case 'NO_HUBSPOT_TRANSFER':
        filterParams.has_hubspot_transfer_for_recent_visit = '0';
        break;
      case 'PENDING':
        filterParams.has_hubspot_transfer_claim = '1';
        break;
      case 'ALL':
      default:
        break;
    }

    switch (companyVisibility) {
      case 'HIDDEN':
        filterParams.is_hidden = 1;
        break;
      case 'ALL':
        // no filters...
        break;
      case 'FILTERED':
        filterParams.is_isp = 1;
        break;
      case 'VISIBLE':
      default:
        filterParams.is_isp = 0;
        filterParams.is_hidden = 0;
    }

    if (companyName && companyName.trim()) {
      filterParams.company_name = `*${companyName.trim()}*`;
    }

    if (countries) {
      filterParams.country = countries;
    }

    if (city && city.trim().length > 0) {
      filterParams.city = `*${city.trim()}*`;
    }

    if (lastSource) {
      filterParams.last_source = lastSource;
    }

    if (lastCampaignKeyword) {
      filterParams.last_campaign_keyword = `*${lastCampaignKeyword.trim()}*`;
    }

    if (lastCampaignName) {
      filterParams.last_campaign_name = `*${lastCampaignName.trim()}*`;
    }

    let from;
    let to;
    if (dateRange && dateRange.length > 0) {
      const [visitStartFrom, visitStartTo] = dateRange;

      from = moment.tz(visitStartFrom.set({
        hour: 0, minute: 0, second: 0, millisecond: 0,
      }), this.props.timezone || 'utc');
      to = moment.tz(visitStartTo.set({
        hour: 23, minute: 59, second: 59, millisecond: 59,
      }), this.props.timezone || 'utc');

      filterParams[`last_visit_timestamp>=${from.toISOString()}`] = null;
      filterParams[`last_visit_timestamp<=${to.toISOString()}`] = null;
    }

    if (leadMarks && leadMarks.length > 0) {
      filterParams.leadMarks = leadMarks;
    }

    if (branches && branches.length > 0) {
      const codesPropName = this.props.useCustomBranches ?
        'classificationCodes.branches' :
        'classificationCodes';

      filterParams[codesPropName] = branches.map(i => i.key);
    }

    return filterParams;
  }

  canHubspotTransferBeCreated = (record) => {
    const createTasks = this.props.currentProject.hubspot_create_tasks;
    const createDeals = this.props.currentProject.hubspot_create_deals;

    if (createTasks) {
      return !record.hubspot_transfer_id_recent;
    }

    if (createDeals) {
      return !record.hs_deal_id;
    }
  }

  render() {
    const { Column } = Table;
    const projectId = this.props.currentProjectId;
    const { isShowDrawer } = this.state;
    const { useCustomBranches } = this.props;
    const showCustomBranches = useCustomBranches && !this.state.showKompassBranches;
    const branchesTitleId = useCustomBranches ? 'Grid.Column.Branches' : 'Grid.Column.ClassificationCodes';

    return (
      <div className={styles.containerLarge}>
        <SearchCreateCompanyModal
          isLoading={!!this.props.loading.effects['hubspot/linkHubspotCompany']}
          description1={
            this.state.transferToHubspot.hasHubspotTransferClaim ?
              'Component.SearchCreateCompanyModal.Description1PendingTask' :
              'Component.SearchCreateCompanyModal.Description1'
          }
          onCancel={this.onTaskCreateCancel}
          visible={this.state.searchCreateCompanyModalVisible}
          companyId={this.state.transferToHubspot.companyId}
          companyName={this.state.transferToHubspot.companyName}
          onCompanySelected={
            this.state.transferToHubspot.hasHubspotTransferClaim ?
              this.matchCompanyToCreatePendingTask :
              this.showCreateTaskPanel
          }
        />
        <div>
          <Sticky
            className="sticky-bar"
            scrollElement=".ant-layout"
            stickyClassName="_sticky"
          >
            <div className="sticky-wrapper">
              <Row className="filtersWrap" type="flex" align="top" justify="space-between">
                <LeadsCompaniesFilter
                  dateFormat={this.props.user.display_datetime_format && this.props.user.display_datetime_format.split(' ')[0]}
                  onChange={this.updateFiltersState}
                  showKompassBranches={show => this.setState({ showKompassBranches: show })}
                  customBranches={this.props.useCustomBranches}
                  timezone={this.props.user.display_timezone}
                  projectId={this.state.projectId}
                  formFields={this.state.filters}
                />
                <ExportFile
                  filter={this.filtersToQueryFilter(this.state.filters)}
                  period={this.state.period}
                  sorting={this.state.sorting}
                  data="companies"
                />
              </Row>
            </div>
          </Sticky>
          <AjaxTable
            keepPage={this.state.tableKeepPage}
            rowKey="id"
            className={[styles.companyAttributesList, styles.noMarginBottom].join(' ')}
            updateKey={JSON.stringify([this.state.filters, this.state.updateTimestamp, this.props.match.params.projectId])}
            getData={this.getData.bind(this)}
            defaultParams={{ sorting: this.state.sorting }}
            replaceRecords={this.state.replaceTableRecords}
          >
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Country' })}
              dataIndex="country"
              key="country"
              className="text-center"
              render={country => <CountryColumnRenderer country={country} />}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.City' })}
              dataIndex="city"
              key="city"
              className="text-center"
              render={city => (<div
                data-label={this.props.intl.formatMessage({ id: 'Grid.Column.City' })}
              >
                {city}
              </div>)}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.CompanyName' })}
              dataIndex="company_name"
              key="company_name"
              className={styles.tableColumnWrap}
              render={companyName => (<div
                data-label={this.props.intl.formatMessage({ id: 'Grid.Column.CompanyName' })}
              >
                {companyName}
              </div>)}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.LastVisitSource' })}
              key="last_referrer_type"
              className="text-center"
              render={(item) => {
                if (!item.last_referrer_type) {
                  return '';
                }

                const data = [item.last_referrer_type.label];
                if (item.last_referrer_keyword) {
                  data.push(`Name: ${item.last_referrer_name}`);
                  data.push(`Keyword: ${item.last_referrer_keyword}`);
                }

                return (<MultiplyItemsColumnRender itemList={data} showLeftNumber={false} />);
              }}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.LastVisitedAt' })}
              dataIndex="last_visit_timestamp"
              key="last_visit_timestamp"
              className={styles.whiteColumn}
              sorter
              defaultSortOrder="descend"
              render={(dateTime) => {
                return (<DateTimeColumnRenderer
                  displayTimezone={this.props.user.display_timezone}
                  displayFormat={this.props.user.display_datetime_format}
                  dateTime={dateTime}
                />);
              }}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.LeadLabel' })}
              dataIndex="lead_marks"
              key="leadMarks"
              className="text-center"
              render={leadMarks => <MultiplyItemsColumnRender itemList={leadMarks.map(i => (i.name ? i.name : ''))} />}
            />
            <Column
              title={this.props.intl.formatMessage({ id: branchesTitleId })}
              dataIndex="classification_codes"
              key="classificationСodes"
              className="text-center"
              render={(codes) => {
                const data = showCustomBranches ? helpers.getUniqueCustomBranches(codes).map(i => i.name) : codes.map(i => (i.label));
                return (<MultiplyItemsColumnRender itemList={data} />);
              }}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Actions' })}
              key="details"
              className="text-center"
              fixed="right"
              width={220}
              render={record => (
                <div className="actions" data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Actions' })}>
                  <Tooltip
                    className="hint" placement="top"
                    title={this.props.intl.formatMessage({ id: 'Component.Leads.VisitsList.Button.Hint.ViewDetails' })}
                  >
                    <Link
                      className="action-wrap" target="_blank"
                      to={`/${projectId}/lead-management/leads/${record.id}/details/`}
                    >
                      <BuildingIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint" placement="top"
                    title={this.props.intl.formatMessage({ id: 'Component.Leads.VisitsList.Button.Hint.QuickView' })}
                  >
                    <button className="action-wrap" onClick={() => this.onQuickView(projectId, record.id)}>
                      <BoltIcon />
                    </button>
                  </Tooltip>
                  <WithHideCompanyPermissions>
                    <span>
                      <Tooltip
                        className="hint"
                        placement="top"
                        title={this.props.intl.formatMessage({ id: record.is_hidden ? 'Component.Leads.VisitsList.Button.Hint.Unhide' : 'Component.Leads.VisitsList.Button.Hint.Hide' })}
                      >
                        <button
                          className="action-wrap"
                          onClick={() => this.hideCompanyToggle(record.id, !record.is_hidden)}
                        >
                          {record.is_hidden ? <EyeFillIcon /> : <EyeIcon />}
                        </button>
                      </Tooltip>
                    </span>
                  </WithHideCompanyPermissions>
                  <WithMarkIspPermissions>
                    <span>
                      <Tooltip
                        className="hint"
                        placement="top"
                        title={this.props.intl.formatMessage({ id: record.is_isp ? 'Component.Leads.VisitsList.Button.Hint.MarkAsNotIsp' : 'Component.Leads.VisitsList.Button.Hint.MarkAsIsp' })}
                      >
                        <button className="action-wrap" onClick={() => this.markISP(record.id, !record.is_isp)}>
                          {record.is_isp ? <NetworkCrossedIcon /> : <NetworkIcon />}
                        </button>
                      </Tooltip>
                    </span>
                  </WithMarkIspPermissions>
                  <Tooltip
                    className="hint" placement="top"
                    title={record.websites.length ? this.props.intl.formatMessage({ id: 'Component.Leads.VisitsList.Button.Hint.OpenWebiste' }) : null}
                  >
                    <a
                      href={record.websites.length ? record.websites[0] : null}
                      className={record.websites.length ? 'action-wrap' : 'action-wrap disabled'}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <LinkIcon />
                    </a>
                  </Tooltip>
                  <WithHubspotProjectPermissions>
                    <Tooltip
                      className="hint" placement="top"
                      title={this.canHubspotTransferBeCreated(record) ? this.props.intl.formatMessage({ id: 'Component.Leads.VisitsList.Button.Hint.TransferToHubspot' }) : ''}
                    >
                      <button
                        style={{
                          backgroundColor: record.has_hubspot_transfer_claim ? 'red' : null,
                          display: (this.props.currentProject.hubspot_create_tasks || this.props.currentProject.hubspot_create_deals) ? 'inherit' : 'none',
                        }}
                        className="action-wrap"
                        onClick={() => (this.canHubspotTransferBeCreated(record) ? this.onTransferToHubspot(record) : this.onTransferredToHubSpot(record))}
                      >
                        {record.has_hubspot_transfer_claim ?
                          <HubspotWhiteIcon /> :
                          this.canHubspotTransferBeCreated(record) ? <HubspotCoralIcon /> : <HubspotCharcoalIcon />}
                      </button>
                    </Tooltip>
                  </WithHubspotProjectPermissions>
                </div>)}
            />
          </AjaxTable>
        </div>
        {isShowDrawer && <Drawer
          width={400}
          placement="right"
          closable
          onClose={this.toggleDrawer}
          visible={isShowDrawer}
        >
          <Spin
            spinning={!!this.props.loading.effects['leads/getDetails'] || !!this.props.loading.effects['matomo/updateStore']}
          >
            <LeadDetailsCard
              allLeadMarks={this.state.allLeadMarks}
              projectId={this.state.projectId}
              leadId={this.state.leadId}
              brancheTitle={this.props.intl.formatMessage({ id: branchesTitleId })}
              toShow={useCustomBranches && !this.state.showKompassBranches}
              showKompassBranches={this.state.showKompassBranches}
            />
          </Spin>
        </Drawer>}
        {/* Create hubspot task */}
        {this.state.createHubspotTransferModalVisible &&
          <CreateHubspotTransferModal
            visible={this.state.createHubspotTransferModalVisible}
            onCancel={this.hideCreateHubspotTransferModal}
            hubspotCompanyId={this.state.transferToHubspot.hubspotCompanyId}
            lxpCompanyId={this.state.transferToHubspot.companyId}
            companyName={this.state.transferToHubspot.companyName}
            companyDomain={this.state.transferToHubspot.companyDomain}
            onTaskCreated={this.onTransferCreated}
          />
        }
        {/* View hubspot task */}
        {this.state.viewHubspotTransferDrawerVisible && this.state.viewHubspotTransfer && <Drawer
          width={400}
          placement="right"
          closable
          onClose={this.hideViewHubspotTransferDrawer}
          visible={this.state.viewHubspotTransferDrawerVisible}
        >
          <ViewHubspotTransfer
            hubspotTransferId={this.state.viewHubspotTransfer.hubspotTransferId}
            onTaskNotFound={this.hideViewHubspotTransferDrawer}
          />
        </Drawer>}
      </div>);
  }
}

export default connect(({ companies, hubspot, loading, app }) => ({
  companies,
  loading,
  hubspot,
  currentProjectId: app.currentProjectId,
  user: app.user,
  useCustomBranches: app.useCustomBranches,
  currentProject: app.currentProject,
}))(injectIntl(LeadsCompaniesOverview));



// WEBPACK FOOTER //
// ./src/components/Leads/LeadsCompaniesOverview/LeadsCompaniesOverview.js